import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class DPBVio extends Component {

    constructor() {
        super();
        this.state = {
            stock: 'nav-item',
            objs: [],
            objsload: false,

            reports: [],
            reportload: false,

            //modal
            cushow:false,
            iscreate:true,
            cargo_name:'',

            spe:1,
            acc:0.25,
            bra:0.25,
            cor:0.25,
            stdate:'',
            eddate:'',
        }
    }
    componentDidMount() {
        this.fetcheddata()
    }
    fetcheddata = () => {
        this.setState({
            objs: [],
            objsload: false,
            //modal
            cushow:false,
            iscreate:true,
            cargo_name:'',
        })
        let baseurl = myconfig.getcargos;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            let tabledata = this.state.reports.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.km}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.specount}</td>
                    <td>{value.spescore}</td>
                    <td>{value.acount}</td>
                    <td>{value.acountscore}</td>
                    <td>{value.bcount}</td>
                    <td>{value.bcountscore}</td>
                    <td>{value.ccount}</td>
                    <td>{value.ccountscore}</td>
                    <td>{value.total}</td>
                </tr>)
            })
            let tableheader = null;
            if (this.state.reports.headers.length > 0) {
                tableheader = <tr>
                    <th>{this.state.reports.headers[0].h1}</th>
                    <th>{this.state.reports.headers[0].h2}</th>
                    <th>{this.state.reports.headers[0].h16}</th>
                    <th>{this.state.reports.headers[0].h3}</th>
                    <th>{this.state.reports.headers[0].h4}</th>
                    <th>{this.state.reports.headers[0].h5}</th>
                    <th>{this.state.reports.headers[0].h6}</th>
                    <th>{this.state.reports.headers[0].h7}</th>
                    <th>{this.state.reports.headers[0].h8}</th>
                    <th>{this.state.reports.headers[0].h9}</th>
                    <th>{this.state.reports.headers[0].h10}</th>
                    <th>{this.state.reports.headers[0].h11}</th>
                    <th>{this.state.reports.headers[0].h12}</th>
                    <th>{this.state.reports.headers[0].h13}</th>
                    <th>{this.state.reports.headers[0].h14}</th>
                    <th>{this.state.reports.headers[0].h15}</th>
                </tr>
            }
            return (<>
                <table className="table table-head-fixed text-nowrap">
                    <thead>
                    {tableheader}
                    </thead>
                    <tbody>
                    {tabledata}
                    </tbody>
                </table>
            </>)
        }
        return (<>{retdata}</>)
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    getreport = (event) => {
        event.preventDefault()
        this.setState({
            reports: [],
            reportload: false,
        })
        let baseurl = myconfig.byvio;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            spe: this.state.spe,
            acc: this.state.acc,
            bra: this.state.bra,
            cor: this.state.cor,
            stdate: this.state.stdate,
            eddate: this.state.eddate,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    reports: res.data,
                    spe: res.data.state.spe,
                    acc: res.data.state.acc,
                    bra: res.data.state.bra,
                    cor: res.data.state.cor,
                    stdate: res.data.state.stdate,
                    eddate: res.data.state.eddate,
                    reportload: true,
                })

            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    render() {
        return (
            <>
                <Nav type="driver_point_by_vio"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Driver Point by Violation</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={myconfig.urlwelcome}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">By Vio</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Point Criteria</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive pt-3 px-2">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Speed Weight</label>
                                                        <input className="form-control" type="text" name="spe"
                                                               onChange={this.inputmgt} value={this.state.spe}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Acceleration Weight</label>
                                                        <input className="form-control" type="text" name="acc"
                                                               onChange={this.inputmgt}
                                                               value={this.state.acc}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Braking Weight</label>
                                                        <input className="form-control" type="text"
                                                               name="bra" onChange={this.inputmgt}
                                                               value={this.state.bra}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Cornering Weight</label>
                                                        <input className="form-control" type="text"
                                                               name="cor" onChange={this.inputmgt}
                                                               value={this.state.cor}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Start Date</label>
                                                        <input className="form-control" type="date" name="stdate"
                                                               onChange={this.inputmgt} value={this.state.stdate}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>End Date</label>
                                                        <input className="form-control" type="date" name="eddate"
                                                               onChange={this.inputmgt} value={this.state.eddate}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <button className="btn btn-outline-primary form-control" onClick={this.getreport}>
                                                            Get Report
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Report Data</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive pt-3 px-2" style={{height: '500px'}}>
                                            <div className="row">
                                                {this.tabledata()}
                                            </div>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default DPBVio;
